// extracted by mini-css-extract-plugin
module.exports = {"dialog-wrapper":"styles_dialog-wrapper__3Zoof","dialog":"styles_dialog__D7PI7","dialog_open":"styles_dialog_open__171-G"};